<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-8">
          <div class="p-3">
           
            <div class="main-video-frame">
              <b-skeleton-img v-if="isDataLoaded"></b-skeleton-img>
              <div class="video" v-html="playedVideo.videoUrl"></div>
            </div>
            <h5 class="sub-title-page">{{ playedVideo.videoTitle }}</h5>
            <p class="text-muted mb-5" v-html="playedVideo.videoArticle">
              
              <SkeletonLoading v-if="isDataLoaded" />
       
            </p>
          </div>
        
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <div class="p-3">
            <div
              class="video-list-container"
              v-for="(playlist, index) in learnContent.learnVideos"
              :key="index"
            >
                    <b-card v-b-toggle="FormatTitle(playlist.title)">
                      <div class="d-flex align-items-center justify-content-between">
                       <b style="margin-left:0.8em;">{{ playlist.title }}</b> 
                         <i class="bi bi-chevron-down mr-2"></i>
                      </div>
                    </b-card>
           
                    <b-collapse :id="FormatTitle(playlist.title)" >
                      <b-card class="video-list-content">
                      <div v-for="(item, index) in playlist.subPlaylist" :key="index">
                        <h5><b>{{ item.subPlaylistTitle }} </b></h5>
                        <ul
                          v-for="(videoContent, index) in item.videos"
                          :key="index"
                          @click="playVideo(videoContent)"
                        >
                          <li>
                            <b>{{ videoContent.subTitle }}</b>
                            <i class="bi bi-caret-right-fill"></i>
                            <label> {{ videoContent.videoTitle }}</label>
                            <p class="lesson-sub-title">
                              {{ videoContent.videoSubtitle }}
                            </p>
                          </li>
                        </ul>
                    </div>
                      </b-card>
                    </b-collapse>
           
            </div>
          </div>
        </div>
      </div>
   
    </div>
       <Footer />
  </div>
</template>

<script>
import navHeader from "../ResearchPages/NavHeader";
import Footer from "../ResearchPages/Footer";
import { mapState } from "vuex";
import SkeletonLoading from "../ResearchPages/SkeletonLoading";

export default {
  components: {
    navHeader,
    Footer,
    SkeletonLoading,
  },
  data() {
    return {
      isDataLoaded: false,
    };
  },

  computed: {
    ...mapState({
      learnContent: (state) => state.philstocksResearch.LearnContent,
      playedVideo: (state) => state.philstocksResearch.playedVideo,
      
    }),
  },

  methods: {
    Learnpage() {
      this.$gtag.event("Learnpage", { method: "Google" });
    },
    playVideo(data) {
      this.playedVideo.videoTitle = data.videoTitle;
      this.playedVideo.videoUrl = data.videoUrl;
      this.playedVideo.videoArticle = data.videoArticle;
    },
    FormatTitle(data) {
      return data.replace(/ /g, "");
    },

    Learn() {
      this.$gtag.event("Learn", { method: "Google" });
    },
    async GetVideoContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetLearnVideo",data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },

  async mounted() {
    this.GetVideoContent(this.$route.query.keyword);
  },
};
</script>

<style></style>

